module.exports = __webpack_public_path__ + "static/img/avatar-offline.77c610ba.png";